export const NAMED_INSURED = {
  MAX_LENGTH: 160, // used for text fields and autocomplete. Named Insured will error in ONESHIELD if longer than 160.
  ATTRIBUTE_FIELDS: ['CustomerName', 'AdditionalNamedInsuredName'],
};
